import React from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { ThemeProvider } from 'styled-components';
import { videoChatTheme } from '../../styles/theme';

const pageStyle = {
  position: 'fixed',
  inset: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#0c1220',
  color: '#ffffff',
  padding: 24,
  textAlign: 'center',
  boxSizing: 'border-box',
  overflow: 'hidden',
};

const cardStyle = {
  maxWidth: 520,
  border: '1px solid rgba(255,255,255,0.14)',
  borderRadius: 14,
  background: 'rgba(255,255,255,0.04)',
  padding: '28px 24px',
};

const titleStyle = {
  margin: 0,
  fontSize: 28,
  fontWeight: 700,
};

const bodyStyle = {
  marginTop: 12,
  marginBottom: 0,
  color: '#c9d6e6',
  fontSize: 15,
  lineHeight: 1.45,
};

const MeetingEnded = ({ t, location }) => {
  const params = new URLSearchParams(location?.search || '');
  const reason = params.get('reason');
  const isUserLeft = reason === 'left';

  let title = t('Informative.Notifying.videoChatEnded');
  let body = t('Video.videoChatEndedDescription');

  if (isUserLeft) {
    title = t('Video.videoChatLeft');
    body = t('Video.videoChatLeftDescription');
  } else if (reason === 'not-participant') {
    title = t('Video.videoChatNotParticipantTitle', 'Meeting unavailable');
    body = t('Video.videoChatNotParticipantDescription', 'You are not part of this meeting.');
  } else if (reason === 'invalid') {
    title = t('Video.videoChatInvalidTitle', 'Invalid meeting link');
    body = t('Video.videoChatInvalidDescription', 'This meeting link is invalid or has expired.');
  } else if (reason === 'unavailable') {
    title = t('Video.videoChatUnavailableTitle', 'Meeting unavailable');
    body = t('Video.videoChatUnavailableDescription', 'This meeting is currently unavailable.');
  }

  const closeTabHint = t('Video.videoChatLeftDescription');

  return (
    <ThemeProvider theme={videoChatTheme}>
      <div style={pageStyle}>
        <div style={cardStyle}>
          <h1 style={titleStyle}>{title}</h1>
          <p style={bodyStyle}>{body}</p>
          {!isUserLeft && <p style={bodyStyle}>{closeTabHint}</p>}
        </div>
      </div>
    </ThemeProvider>
  );
};

export default withRouter(withTranslation()(MeetingEnded));
